


























import Vue from 'vue';
import { defineComponent, Ref, ref, computed, reactive, onMounted, onBeforeUnmount } from '@vue/composition-api';
import Hammer from 'hammerjs';

const componentName = 'wok-mobile-bottom-sheet';

export default defineComponent({
    name: componentName,

    setup(props, context) {
        const overlay = ref() as Ref<HTMLDivElement>;
        const sheet = ref() as Ref<HTMLDivElement>;

        let hammerManager: HammerManager;

        const state = reactive({
            animatable: false,
            visible: false
        });

        const wrapperClasses = computed(() => {
            return {
                'wok--bottom-sheet__wrapper': true,
                'wok--bottom-sheet--visible': state.visible,
                'wok--bottom-sheet--animatable': state.animatable,
                'wok--bottom-sheet--with-actions': hasActions.value
            };
        });

        const onAfterEnter = () => {
            state.visible = true;
            context.emit('sheet-visible');
        };

        const onAfterLeave = () => {
            state.visible = false;
        };

        const onTransitionEnd = () => {
            state.animatable = false;
        };

        const onRequestHideSheet = () => {
            context.emit('hide-sheet');
        }

        const initHammerRecognizers = () => {
            let sensitivity = 25;

            hammerManager.on('pan', (e) => {
                let percentage = 100 * (e.deltaY / window.innerHeight);
                let percentageCalculated = 0;
                let overlayOpacity = 0;

                if (e.target == sheet.value) {
                    percentageCalculated = Math.max(percentage, 0);
                    overlayOpacity = (100 - percentage) / 100;

                    sheet.value.style.transform = `translateY(${percentageCalculated}%)`;
                    overlay.value.style.opacity = `${overlayOpacity}`;

                    if (e.isFinal) {
                        if (e.velocityY < -1) {
                            state.animatable = true;
                            sheet.value.style.transform = '';
                            overlay.value.style.opacity = '';
                        }
                        else if (e.velocityY > 1) {
                            onRequestHideSheet();
                            sheet.value.style.transform = '';
                            overlay.value.style.opacity = '';
                        }
                        else {
                            if (percentage <= sensitivity) {
                                state.animatable = true;
                                sheet.value.style.transform = '';
                                overlay.value.style.opacity = '';
                            }
                            else if (percentage >= sensitivity) {
                                onRequestHideSheet();
                                sheet.value.style.transform = '';
                                overlay.value.style.opacity = '';
                            }
                        }
                    }
                }
            });
        }

        const hasActions = computed(() => {
            return context.slots.actions;
        });

        onMounted(() => {
            if (sheet.value) {
                sheet.value.addEventListener('transitionend', onTransitionEnd, false);

                hammerManager = new Hammer.Manager(sheet.value, { // Create an Hammer Manager with Pan recognizer
                    recognizers: [
                        [Hammer.Pan, { 
                            threshold: 0, 
                            pointers: 0,
                        }]
                    ]
                });

                initHammerRecognizers(); // Initialize recognizers event listeners
            }
        });

        onBeforeUnmount(() => {
            if (sheet.value) {
                sheet.value.removeEventListener('transitionend', onTransitionEnd, false);
            }

            if (hammerManager) {
                hammerManager.destroy(); // Unbinds all events and input events and makes the manager unusable
            }
        });

        return {
            overlay,
            sheet,
            wrapperClasses,
            onAfterEnter,
            onAfterLeave,
            onRequestHideSheet,
            hasActions
        }
    }
})
